import React, { useEffect, useRef, useState } from "react";
import FormRender from "../../components/FormRender";
import {
  AFFINITY_FORM_SETTINGS,
  FakeFieldData,
  NewListFields,
  VALUE_TYPE_TO_NAME_MAPPINGS,
} from "../../helper";
import Select from "react-select";
import { TableCustom } from "../../components/Table";
import useAxiosInstance from "../../hooks/useAxios";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { FaExpand, FaExpandArrowsAlt } from "react-icons/fa";
import { FaArrowDown, FaSortDown } from "react-icons/fa6";
import { parseJsonLogic } from "react-querybuilder/parseJsonLogic";
import { v4 as uuid } from "uuid";
import { formatQuery, QueryBuilder, Field } from "react-querybuilder";
import "react-querybuilder/dist/query-builder.css";
import axios from "axios";

const FieldComp = ({ elem, setFormData, formData }) => {
  const [expand, setExpand] = useState(false);
  return (
    <div
      key={elem.id}
      onClick={() => {
        // setFormData((prev) => ({ ...prev, field: elem }));
      }}
      className={`px-3 cursor-pointer py-2 w-full rounded-md ${
        formData?.field?.id == elem.id ? "border-black border" : "border"
      } hover:border-black hover:border`}
    >
      <p className="text-base font-semibold ">{elem.name}</p>
      <p className="flex justify-between items-center">
        <div>
          <span className="text-sm font-normal">
            Type: {VALUE_TYPE_TO_NAME_MAPPINGS?.[elem.value_type]}
          </span>
        </div>{" "}
        {elem?.dropdown_options?.length !== 0 && (
          <div className={expand ? "rotate-180" : "rotate-0"}>
            <FaSortDown
              onClick={() => {
                setExpand((prev) => !prev);
              }}
            />
          </div>
        )}
      </p>
      {expand && (
        <div>
          <p className="text-sm font-medium mt-3">Values</p>
          {elem.dropdown_options.map((dp) => {
            return (
              <div
                key={dp.id}
                className="flex justify-between text-sm font-normal"
              >
                <div>{dp.id}</div>
                {dp.text}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

function getSelectedRange() {
  const sel = window.getSelection();
  if (!sel || sel.rangeCount === 0) return null;
  return sel.getRangeAt(0).toString();
}

const FieldSection = ({ formData, setFormData, setFields, fields }) => {
  const editorRef = useRef();
  const axiosInstance = useAxiosInstance()  
  return (
    <div>
      <button
        className="bg-black text-white text-sm px-3 py-1 rounded-md mt-2 mb-4"
        onClick={async () => {
          try {
            const resp = await axiosInstance.post(
              "integrations/affinity/fetch_field_data/",
              {
                list_id: formData.list_id,
                api_key: formData.api_key,
                mode: "cached",
              }
            );
            setFields(resp.data);
          } catch (error) {}
        }}
      >
        {" "}
        Fetch fields (Cached)
      </button>
      <button
        className="bg-black text-white text-sm px-3 py-1 rounded-md mt-2 mb-4"
        onClick={async () => {
          try {
            const resp = await axiosInstance.post(
              "integrations/affinity/fetch_field_data/",
              {
                list_id: formData.list_id,
                api_key: formData.api_key,
                mode: "cached",
              }
            );
            setFields(resp.data);
          } catch (error) {}
        }}
      >
        {" "}
        Fetch fields (Refreshed)
      </button>
      <div>
        <span className="text-base font-semibold mb-3">Fields Details</span>
        <div className="w-full grid grid-cols-3 gap-3 m-3">
          {fields.map((elem) => {
            return (
              <FieldComp
                setFormData={setFormData}
                formData={formData}
                key={elem}
                elem={elem}
              />
            );
          })}
        </div>
        {fields.length !== 0 && (
          <QueryBuilder
            fields={fields.map((field) => ({
              ...field,
              name: field.id,
              label: field.name,
            }))}
            query={formData.query}
            onQueryChange={(e) => {
              setFormData((prev) => ({ ...prev, query: e }));
            }}
            parseNumbers={true}
          />
        )}
        Preview
        <div className="bg-slate-200 px-3 py-2 rounded-lg">
          <code>
            {JSON.stringify(formatQuery(formData.query, "jsonlogic"))}
          </code>
        </div>
      </div>
    </div>
  );
};

const OutputMappingTableMappings = ({ tableRows, setTableRows, fields }) => {
  const tableColumns = [
    {
      label: "L1",
      key: "heading_category",
      width: "25%",
    },
    {
      label: "L2",
      key: "heading_view",
      width: "25%",
    },
    {
      label: "View Name",
      key: "workflow_view__name",
      width: "25%",
    },
    {
      label: "Type",
      key: "workflow_view__name",
      type: "select-type",
      width: "25%",
    },
    {
      label: "Columns Mapping",
      type: "select-columns",
      key: "workflow_view__name",
      width: "25%",
    },
  ];
  tableColumns[3]["Cell"] = ({ row }) => {
    return (
      <select
        onChange={(e) => {
          setTableRows((prev) => {
            let rowToUpdate = JSON.parse(
              JSON.stringify(prev.find((item) => item.pk == row.pk) || {})
            );
            rowToUpdate["type_value"] = e.target.value;

            let allRows = [];
            prev.forEach((it) => {
              if (it.pk == row.pk) {
                allRows.push(rowToUpdate);
              } else {
                allRows.push(it);
              }
            });
            return allRows;
          });
        }}
        value={row.type_value}
      >
        <option value="">Choose</option>
        <option value="column">Column</option>
        <option value="note">Note</option>
      </select>
    );
  };
  tableColumns[4]["Cell"] = ({ row }) => {
    const tableRow = JSON.parse(
      JSON.stringify(tableRows.find((item) => item.pk == row.pk) || {})
    );
    if (tableRow.type_value != "column") {
      return <></>;
    }
    return (
      <select
        onChange={(e) => {
          setTableRows((prev) => {
            let rowToUpdate = JSON.parse(
              JSON.stringify(prev.find((item) => item.pk == row.pk) || {})
            );
            rowToUpdate["field_value"] = e.target.value;

            let allRows = [];
            prev.forEach((it) => {
              if (it.pk == row.pk) {
                allRows.push(rowToUpdate);
              } else {
                allRows.push(it);
              }
            });
            return allRows;
          });
        }}
        value={row.field_value}
      >
        <option value="">Choose</option>
        {fields.map((field) => (
          <option value={field.id}>{field.name}</option>
        ))}
      </select>
    );
  };
  return <TableCustom columns={tableColumns} data={{ data: tableRows }} />;
};
const normalizeBoolean = (val) => {
  if (val === "true" || val === true) return true;
  if (val === "false" || val === false) return false;
  return val; 
};
const EditAffinity = () => {
  const axiosInstance = useAxiosInstance();
  const history = useNavigate();
  const [formData, setFormData] = useState({
    api_key: "",
    list_id: "",
    workflow_id: { value: "", label: "" },
    primary_key_during_update: "",
    query: {
      combinator: "and",
      rules: [],
    },
    // query: parseJsonLogic({"and":[{"or":[{"==":[{"var":"new_company"},"true"]},{"==":[{"var":"5105709"},19523677]}]},{"==":[{"var":"list_id"},297640]},{"==":[{"var":"5105711"},226951880]}]})
  });
  const [formData2, setFormData2] = useState({
    default_owner: "",
    list_type: "organizations",
    append_wokelo_credits_line: true,
    append_in_opportunity_too: true,
  });
  const [fields, setFields] = useState([]);
  const { allReportTypes } = useSelector((e) => e.globalAuth);
  const [outputMappings, setOutPutMappings] = useState([]);
  const [payloadInputs, setPayloadInputs] = useState([]);
  const [formDataPayloadInputs, setFormDataPayloadInputs] = useState({});
  const [initialOutputMappings, setInitialOutPutMappings] = useState([]);
  const [saving,setSaving] = useState(false);
  useEffect(() => {
    axiosInstance
      .get(
        `integrations/affinity/get_affinity_configs/?unique_affinity_id=${window.location.pathname
          .split("/")
          .pop()}`
      )
      .then((res) => {
        const config = res?.data?.data;
        const primary_key_during_update = fields.find(
            (field) =>
              field.id === config?.field_value_mappings?.primary_key_during_update
          )
        const owner = fields.find((field) => field.id === config?.owner?.field_id)
        
        setFormData({
          api_key: config.api_key,
          primary_key_during_update: {
            value: primary_key_during_update?.id,
            label: primary_key_during_update?.name,
          },
          query: config.field_value_mappings.query,
          workflow_id: allReportTypes.find(
            (item) => item.value == config.workflow_id
          ),
          list_id: config.list_id,
          owner: {
            value: owner?.id,
            label: owner?.name,
          },
        });
        setFormData2(config?.meta)
        setPayloadInputs(
          config.input_mapping.map((item) => ({
            label: item.label,
            field_id: item?.field_id,
            obj_field_id: {
                "value":fields.find((field) => field.id === item?.field_id)?.id,
                "label":fields.find((field) => field.id === item?.field_id)?.name
            },
            id: uuid(),
          }))
        );
        setInitialOutPutMappings(
          config.output_mapping.map((item) => ({
            type_value: item.type,
            field_value: item.field_id,
            id: item.id,
          }))
        );
      })
      .catch();
  }, [window.location.pathname.split("/").pop(), fields]);

  useEffect(() => {
    if (!formData.workflow_id) {
      return;
    }
    axiosInstance
      .get(
        `integrations/affinity/fetch_workflow_structures/?workflow_id=${formData?.workflow_id?.value}`
      )
      .then((res) => {
        let newData = []
        res.data.forEach(it=>{
            newData.push({...it,...initialOutputMappings.find(item=>item.id == it.id)})
        })
        setOutPutMappings(newData)
    })
      .catch();
  }, [formData.workflow_id, initialOutputMappings]);

  AFFINITY_FORM_SETTINGS[2].children = (
    <FieldSection
      formData={formData}
      setFormData={setFormData}
      fields={fields}
      setFields={setFields}
    />
  );

  useEffect(() => {
    console.log(formData.query);
  }, [formData.query]);

  return (
    <div className="w-full px-6">
      <div className="p-3 my-5 border rounded-lg bg-white w-full">
        <p className="text-2xl text-black font-medium mb-4 flex justify-between">
          <p>Affinity Management</p>
        </p>
        <FormRender
          formData={formData}
          formSettings={AFFINITY_FORM_SETTINGS}
          setFormData={setFormData}
          select_options={{
            workflow_id: allReportTypes,
            primary_key_during_update: fields.map((elem) => ({
              value: elem.id,
              label: elem.name,
            })),
            owner: fields.map((elem) => ({
              value: elem.id,
              label: elem.name,
            })),
          }}
        />
        or
          {/* list_type: "organizations",
    append_wokelo_credits_line: true,
    append_in_opportunity_too: true, */}
        <FormRender
          formSettings={[
            { label: "Default Owner", type: "text", saveKey: "default_owner" },
            {
              label: "list_type",
              type: "select",
              saveKey: "list_type",
              options: [
                // { label: "choose", value: null },
                { label: "organizations", value: "organizations" },
                { label: "opportunities", value: "opportunities" },
              ],
            },
            {
              label: "append_in_opportunity_too",
              type: "select",
              saveKey: "append_in_opportunity_too",
              options: [
                // { label: "choose", value: null },
                { label: "True", value: true },
                { label: "False", value: false },
              ],
            },
            {
              label: "append_wokelo_credits_line",
              type: "select",
              saveKey: "append_wokelo_credits_line",
              options: [
                // { label: "choose", value: null },
                { label: "True", value: true },
                { label: "False", value: false },
              ],
            },
           
          ]}
          formData={formData2}
          setFormData={setFormData2}
        />
        Output Mappings
        <OutputMappingTableMappings
          tableRows={outputMappings}
          setTableRows={setOutPutMappings}
          fields={fields}
        />
        <div>
          <div className="px-3 py-2 bg-slate-200 rounded-lg">
            <span className="text-sm font-medium">Payload Inputs</span>
            <FormRender
              formSettings={[
                { label: "Key Name", type: "text", saveKey: "label" },
                {
                  label: "Column",
                  type: "react-single-select",
                  saveKey: "obj_field_id",
                },
              ]}
              formData={formDataPayloadInputs}
              select_options={{
                obj_field_id: fields.map((elem) => ({
                  value: elem.id,
                  label: elem.name,
                })),
              }}
              setFormData={setFormDataPayloadInputs}
            />
            <button
              onClick={() => {
                setPayloadInputs((prev) => {
                  return [
                    ...prev,
                    {
                      ...formDataPayloadInputs,
                      id: uuid(),
                      field_id: formDataPayloadInputs?.obj_field_id?.value,
                    },
                  ];
                });
                setFormDataPayloadInputs({});
              }}
            >
              add
            </button>
            <TableCustom
              data={{ data: payloadInputs }}
              columns={[
                {
                  label: "Label",
                  key: "label",
                  width: "25%",
                },
                {
                  label: "Field",
                  key: "field_id",
                  width: "25%",
                },
              ]}
              handleDelete={(id) =>
                setPayloadInputs((prev) => prev.filter((it) => it.id !== id))
              }
              handleSelect={(id) =>
                setPayloadInputs((prev) => {
                  setFormDataPayloadInputs(prev.find((it) => it.id == id));
                  return prev;
                })
              }
            />
          </div>
        </div>
      </div>

      <button
        className="px-3 py-1 mt-4 border text-white bg-black rounded-lg text-base disabled:bg-white disabled:text-black disabled:cursor-not-allowed "
        onClick={() => {
          const payload = {
            unique_affinity_id:window.location.pathname.split('/').pop(),
            api_key: formData.api_key,
            field_value_mappings: {
              primary_key_during_update:
                formData?.primary_key_during_update?.value, //field_id
              query: formData.query,
              base_condition: formatQuery(formData.query, "jsonlogic"),
            },
            list_id: Number(formData.list_id),
            workflow_id: formData?.workflow_id?.value, //workflow_id
            input_mapping: payloadInputs.map((item) => ({
              label: item.label,
              field_id: item.field_id,
              id: item.id,
            })), //label, field_id, id
            output_mapping: outputMappings
              .map((item) => ({
                type: item.type_value,
                field_id: item.field_value ? Number(item.field_value) : null,
                id: item.id,
                value_key: item.id,
              }))
              .filter(
                (item) =>
                  item.type == "note" ||
                  (item.type == "column" && item.field_id)
              ), //field_id, value_key, type, id
            owner: { label: "user", field_id: formData?.owner?.value }, //label-> user, field_id
            scenarios: ["created", "updated"],
    //          append_wokelo_credits_line: true,
    // append_in_opportunity_too: true,
            meta: { default_owner: formData2.default_owner, ...formData2, "append_wokelo_credits_line":normalizeBoolean(formData2.append_wokelo_credits_line),"append_in_opportunity_too":normalizeBoolean(formData2.append_in_opportunity_too)}, //default owner in this
          };

          setSaving(true)  
                    axiosInstance.post('integrations/affinity/update/', payload).then(
                      res=>{
                        if(res.status == 200){
                          toast.success('edited Successfully!')
                        }else{
                          toast.error(res?.data?.response_text)
                        }
                        setSaving(false)
                      }
                    ).catch(err=>{
                        setSaving(false)
                        toast.error(err?.response?.data?.response_text || 'Something went wrong!')
                    })
        }}
      >
        Edit
      </button>
    </div>
  );
};

export default EditAffinity;
